import { __rest } from "tslib";
import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import { globalTheme } from '../../theme';
export function withColorTheme(Component) {
    return (_a) => {
        var { color } = _a, rest = __rest(_a, ["color"]);
        const baseColors = ["primary", "secondary", "inherit", "default"];
        if (!baseColors.includes(color)) {
            let theme;
            if (color === 'seller') {
                theme = globalTheme("green");
                color = 'primary';
            }
            else if (color === 'tertiary') {
                theme = globalTheme("tertiary");
                color = 'primary';
            }
            else if (color === 'red') {
                theme = globalTheme();
                color = 'primary';
            }
            else
                theme = globalTheme();
            return (React.createElement(ThemeProvider, { theme: theme },
                React.createElement(Component, Object.assign({ color: color }, rest))));
        }
        else
            return React.createElement(Component, Object.assign({ color: color }, rest));
    };
}
